(() => {
  const initialized = new WeakSet();

  function findOriginalButton(bar) {
    const form = bar.closest('form[data-product-form]') || bar.closest('form');
    if (!form) return null;

    return Array.from(form.querySelectorAll('.product-form__cart-submit')).find(
      (button) => !button.closest('.sticky-atc-bar')
    ) || null;
  }

  function bindStickyAtc(bar) {
    if (initialized.has(bar)) return;

    const originalButton = findOriginalButton(bar);
    if (!originalButton) return;

    initialized.add(bar);

    let ticking = false;
    const update = () => {
      ticking = false;
      if (!document.documentElement.contains(bar) || !document.documentElement.contains(originalButton)) return;

      const rect = originalButton.getBoundingClientRect();
      bar.classList.toggle('immut-passed-main-atc', rect.bottom <= 0);
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  }

  function ensureCartTrust() {
    document.querySelectorAll('.quick-cart__submit').forEach((checkoutButton) => {
      const footer = checkoutButton.parentElement;
      if (!footer || footer.querySelector('.quick-cart__footer-trust')) return;

      const trust = document.createElement('div');
      trust.className = 'quick-cart__footer-trust';
      trust.setAttribute('data-immut-cart-trust', '');
      trust.innerHTML = `
        <div class="quick-cart__footer-trust-row">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="6" cy="6" r="2.5" stroke="currentColor" stroke-width="1.3"/><circle cx="6" cy="18" r="2.5" stroke="currentColor" stroke-width="1.3"/><path d="M8.3 7.5 20 18M8.3 16.5 20 6" stroke="currentColor" stroke-width="1.3"/></svg>
          <span>受注仕立てで、ひとつずつお作りします。</span>
        </div>
        <div class="quick-cart__footer-trust-row">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7M3 4v4h4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span>お届けから7日間、返品・交換OK。</span>
        </div>`;

      footer.insertBefore(trust, checkoutButton);
    });
  }

  function init() {
    document.querySelectorAll('.sticky-atc-bar').forEach(bindStickyAtc);
    ensureCartTrust();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  const observer = new MutationObserver(() => {
    init();
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  window.addEventListener('pageshow', init);
})();
